<template>
	<div class="popup_high_right side-popup" :class="['level-'+level]">

		<a @click="close()" v-if="!level" class="close_popup_btn">
			<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
		</a>

		<loading v-if="loading" />
		<div v-else class="popup-container scroll">
			<h3 class="title" >
				<back-btn v-if="level" class="back-btn" @click="close()" />
				<span class="layout-row">
					{{title}}
				</span>
			</h3>

<!--			<div class="order-status-row">-->
<!--				<span class="label">Customer:</span>-->
<!--				<span class="value">-->
<!--					name-->
<!--				</span>-->
<!--				<span class="value">-->
<!--					customer.email-->
<!--				</span>-->
<!--				<div class="flex"></div>-->
<!--								<quick-actions-btn :items="['Delete customer']" @menuClick="" />-->
<!--			</div>-->


			<div class="layout-column flex">
				<slot></slot>
			</div>

		</div>

		<div class="popup-actions layout-row">
			<slot name="actions"></slot>
		</div>

	</div>
</template>

<script>
import Loading from "@/components/Loading";
import BackBtn from "@/components/base/back-btn";
import VButton from "@/components/base/v-button";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
export default {
	name: "side-popup", components: {QuickActionsBtn, VButton, BackBtn, Loading},
	props:{
		level:{
			type: Number,
			default: 0,
		},
		loading:{
			type: Boolean,
			default: false,
		},
		title:{
			type: String,
			default: "",
		},
	},
	data() {
		return {}
	},
	methods:{
		close() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
.side-popup {
	padding: 0;
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}
	.basic-details {
		margin: 15px 0;
	}
	.order-number {
		color: $black;
		margin-left: 5px;
	}
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 3px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		svg {
			//color: #18d7ae;
			height: 18px;
			&.refund {
				color: $black;
			}
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	&.level-3 {
		max-width: 540px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.03);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}

	.order-status-row {
		margin-top: 10px;
		margin-bottom: 10px;
		display: flex;
		flex-direction: row;
		font-size: 13px;
		align-items: center;
		color: #26252e;
		.label {
			font-weight: bold;
			margin-right: 10px;
		}
		.value {
			display: flex;
			flex-direction: row;
			margin-right: 30px;
			margin-left: 5px;
		}
	}
}
</style>
